module.exports = __webpack_public_path__ + "img/menu-outline.02ca27ab.svg";